// src/components/BasculeEspace.jsx — LA BASCULE sous la barre d'onglets
// (réorganisation orchestrateur 7 → 4, maquette Dimitri 2026-08-19).
//
// Deux usages : « Planning » (Aujourd'hui / Le mois) et « À décider »
// (Demandes / Incidents / Contrôle — chacune avec SA pastille). Maquette :
// fond #f6f8fa, rayon 9 ; l'actif en BLANC avec une ombre légère, texte
// #233240 gras ; l'inactif sans fond, texte #5c6773.
//
// ⚠️ AUCUNE mémoire ici : l'entrée active vient du parent (l'onglet courant)
// — « ouvre toujours sur Aujourd'hui » est garanti par la nav, pas par nous.

import { DS } from '../lib/ui'
import useEtroit from '../lib/useEtroit'

// LA BASCULE DE PAGE a DEUX habits (correction Dimitri 2026-08-22 :
// « l'ordinateur ne doit pas bouger — rien du tout ») :
//   · GRAND ÉCRAN : l'apparence historique — boîte #f6f8fa rayon 9, actif
//     BLANC ombré, texte #233240 gras ;
//   · TÉLÉPHONE (< 860) : barre pleine largeur fond blanc filet inférieur,
//     actif = texte navy GRAS + TRAIT 2.5 px navy dessous, 46 px, pour se
//     distinguer de la pastille de la frise.
export default function BasculeEspace({ entrees, actif, onChange, testId }) {
  const etroit = useEtroit()
  if (!Array.isArray(entrees) || entrees.length === 0) return null
  return (
    <div data-testid={testId} role="tablist"
      style={etroit
        ? { display: 'flex', width: '100%', background: '#fff',
            borderBottom: '1px solid #e8edf4', marginBottom: 12 }
        : { display: 'inline-flex', gap: 3, background: '#f6f8fa',
            borderRadius: 9, padding: 3, marginBottom: 12 }}>
      {entrees.map((e) => {
        const estActif = e.id === actif
        const Icone = e.icone || null
        return (
          <button key={e.id} type="button" role="tab"
            data-testid={`${testId}-${e.id}`}
            aria-selected={estActif}
            onClick={() => { if (!estActif) onChange(e.id) }}
            className="fbz-press fbz-cible-tactile"
            style={etroit
              ? { display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                  gap: 6, flex: 1, minHeight: 46, padding: '0 13px', border: 'none',
                  background: 'none', borderRadius: 0,
                  position: 'relative',
                  color: estActif ? '#233240' : '#5c6773',
                  fontSize: 12, fontWeight: estActif ? 700 : 500,
                  fontFamily: DS.fontBody, cursor: estActif ? 'default' : 'pointer',
                  whiteSpace: 'nowrap' }
              : { display: 'inline-flex', alignItems: 'center', gap: 6,
                  padding: '7px 13px', borderRadius: 7, border: 'none',
                  background: estActif ? '#fff' : 'none',
                  boxShadow: estActif ? '0 1px 4px rgba(35,50,64,.14)' : 'none',
                  color: estActif ? '#233240' : '#5c6773',
                  fontSize: 12, fontWeight: estActif ? 700 : 500,
                  fontFamily: DS.fontBody, cursor: estActif ? 'default' : 'pointer',
                  whiteSpace: 'nowrap' }}>
            {Icone && <Icone size={14} strokeWidth={2}
              color={estActif ? (etroit ? '#3d5166' : '#233240') : '#98a2ad'} />}
            {e.label}
            {etroit && estActif && (
              <span aria-hidden="true" style={{ position: 'absolute', bottom: 0,
                left: '16%', right: '16%', height: 2.5, background: '#3d5166',
                borderRadius: 1 }} />
            )}
            {e.pastille?.count > 0 && (
              <span data-testid={`${testId}-${e.id}-pastille`}
                style={{ minWidth: 17, height: 17, padding: '0 5px',
                  borderRadius: 9, background: e.pastille.fond || '#b8412b',
                  color: '#fff', fontSize: 9.5, fontWeight: 700,
                  display: 'inline-flex', alignItems: 'center',
                  justifyContent: 'center', boxSizing: 'border-box' }}>
                {e.pastille.count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
